import { array, option } from "fp-ts"
import { pipe } from "fp-ts/function"

export interface SocialLinkableVM {
  facebookUrl: option.Option<string>
  instagramUrl: option.Option<string>
  linkedInUrl: option.Option<string>
  pinterestUrl: option.Option<string>
  tikTokUrl: option.Option<string>
  twitterUrl: option.Option<string>
  vimeoUrl: option.Option<string>
  youTubeUrl: option.Option<string>
}

export const hasSomeSocialLinks = (socialLinkable: SocialLinkableVM) =>
  pipe(
    [
      socialLinkable.facebookUrl,
      socialLinkable.instagramUrl,
      socialLinkable.linkedInUrl,
      socialLinkable.pinterestUrl,
      socialLinkable.tikTokUrl,
      socialLinkable.twitterUrl,
      socialLinkable.vimeoUrl,
      socialLinkable.youTubeUrl,
    ],
    array.some(option.isSome)
  )
